<template>
  <a-card :bordered="false" class="card-area">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <!-- 搜索区域 -->
      <a-form layout="inline">
        <a-row :gutter="16">
          <!-- 第一行：常显搜索项（非时间选择器） -->
          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.barCodeNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-textarea
                  :placeholder="$t('dashboard.order.placeholderBarCodeNo')"
                  :autoSize="{minRows:1, maxRows:2}"
                  v-model="queryParam.barCodeNo"
                  allow-clear
                  style="width: 100%">
              </a-textarea>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.wcBarCodeNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                  :placeholder="$t('dashboard.order.placeholderWcBarCodeNo')"
                  v-model="queryParam.wcBarCodeNo"
                  style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.orderStatus')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-select
                  v-model="queryParam.orderStatus"
                  :placeholder="$t('dashboard.order.placeholderOrderStatus')"
                  style="width: 100%">
                <a-select-option v-for="(value, key) in dictEum" :key="key" :value="key">{{ value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12" :xs="24">
            <a-form-item :label="$t('dashboard.order.toCustIdCardNo')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <a-input
                  :placeholder="$t('dashboard.order.placeholderToCustIdCardNo')"
                  v-model="queryParam.toCustIdCardNo"
                  style="width: 100%"/>
            </a-form-item>
          </a-col>

          <!-- 第二行：可折叠搜索项（非时间选择器） -->
          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.toCustLinkman')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderToCustLinkman')"
                    v-model="queryParam.toCustLinkman"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.toCustTel')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderToCustTel')"
                    v-model="queryParam.toCustTel"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.siteName')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    show-search
                    v-model="queryParam.siteName"
                    :placeholder="$t('dashboard.order.placeholderSiteName')"
                    style="width: 100%">
                  <a-select-option v-for="d in selectedItems" :key="d.id" :value="d.name">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.settlemenType')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.settlemenType"
                    :placeholder="$t('dashboard.order.placeholdersettlemenType')"
                    style="width: 100%">
                  <a-select-option v-for="(value, key) in dictSettlemenTypeEum" :key="key" :value="key">
                    {{ value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <!-- 第三行 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.isPayment')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-select
                    v-model="queryParam.isPayment"
                    :placeholder="$t('dashboard.order.placeholderIsPayment')"
                    style="width: 100%">
                  <a-select-option value="0">未收款</a-select-option>
                  <a-select-option value="1">已收款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.waybillNumber')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-textarea
                    :placeholder="$t('dashboard.order.placeholderWaybillNumber')"
                    :autoSize="{minRows:1, maxRows:2}"
                    v-model="queryParam.waybillNumber"
                    allow-clear
                    style="width: 100%">
                </a-textarea>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.settlementCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderSettlementCode')"
                    v-model="queryParam.settlementCode"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.productCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderProductCode')"
                    v-model="queryParam.productCode"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <!-- 第四行 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.sumBoxNum')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    :placeholder="$t('dashboard.order.placeholderSumBoxNum')"
                    v-model="queryParam.sumBoxNum"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <!-- 第四行 -->
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.mainMailCode')" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-textarea
                    :placeholder="$t('dashboard.order.placeholderMainMailCode')"
                    :autoSize="{minRows:1, maxRows:2}"
                    v-model="queryParam.mainMailCode"
                    allow-clear
                    style="width: 100%">
                </a-textarea>
              </a-form-item>
            </a-col>

            <!-- 时间选择器单独一行（每行3个） -->
            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('antd.table.createTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.createTimeRend"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')]}"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onCreatDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.outboundTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.createTimeRange"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item :label="$t('dashboard.order.paymentTime')" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="queryParam.payTimeRange"
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm',defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="[$t('antd.table.startTime'), $t('antd.table.endTime')]"
                    @change="onPayDateChange"
                    @ok="onDateOk"/>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator"
         style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
      <div style="flex: 1;">
        <a-button type="primary" icon="download" @click="handleAsyncExportXls()" :loading="exportLoading" style="margin-right: 8px;">
          {{ exportLoading ? '导出中...' : $t('antd.table.export') }}
        </a-button>
        <a-button type="danger" @click="handleAddTrajectory()" style="margin-right: 8px;">
          {{ $t('antd.table.newTrajectory') }}
        </a-button>
        <a-button style="background-color: #c7254e; color: #FFFFFF" @click="handleModifyOrderNumber">
          {{ $t('antd.table.modifyOrderNumber') }}
        </a-button>
        <a-button style="background-color: #07a136; color: #FFFFFF" @click="handlePaymentOutbound">
          已收款出库
        </a-button>
      </div>

      <div style="flex: 1; text-align: right;">
        <a-button type="primary" icon="search" @click="handleSearchQuery()" style="margin-right: 8px;">
          {{ $t('antd.table.search') }}
        </a-button>
        <a-button icon="reload" @click="handleSearchReset({},0)" style="margin-right: 8px;">
          {{ $t('antd.table.reset') }}
        </a-button>
        <a @click="handleToggleSearch">
          {{ toggleSearchStatus ? $t('antd.table.up') : $t('antd.table.down') }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
        </a>
      </div>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <div style="display: flex;gap: 10px">
          <div style="display: flex; align-items: center; gap: 5px">
            <span>{{ $t('dashboard.order.totalAmount') }}:</span>
            <span style="font-weight: 600; color: #2f54eb">{{ selectStatistics.totalAmount }}</span>
            <span style="font-size: 0.8em; margin-left: 1px; color: #666">UZS</span>
          </div>
          <div>|</div>
          <div>
            <i class="anticon anticon-info-circle ant-alert-icon"></i>
            {{ $t('antd.table.selected') }}&nbsp;
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>&nbsp;
            {{ $t('antd.table.item') }}&nbsp;&nbsp;
            <a style="margin-left: 24px" @click="handleClearSelection">{{ $t('antd.table.clear') }}</a>
          </div>
        </div>
      </div>
      <a-table ref="table" size="middle" bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
               @change="handleTableChange"
               :scroll="{ x: '100vw' }"
      >

        <span slot="tags" slot-scope="tags">
          <a-tag
              :color="getTagColor(tags + '')">
            {{ aDouble(tags + '') }}
          </a-tag>
        </span>

        <span slot="paymentStatus" slot-scope="isPayment">
          <a-tag :color="isPayment == '0' ? 'red' : isPayment == '1' ? 'green' : ''">
            {{ paymentStatus(isPayment + '') }}
          </a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleInfor(record)">{{ $t('antd.table.infor') }}</a>
          <a-divider type="vertical"/>
          <a @click="showEditModal(record)">修改</a>
        </span>
      </a-table>

      <!-- 表单区域 -->
      <a-drawer :title="drawerTitle" placement="right" :closable="true" :destroyOnClose="true" :width="1000"
                :bodyStyle="{ backgroundColor: '#cdcdcd' }" :visible="drawerVisible"
                :after-visible-change="afterVisibleChange"
                @close="onDrawerClose">
        <OrderInfor :dictEum="dictEum" :dictSettlemenTypeEum="dictSettlemenTypeEum" :inforData="orderInforData"
                    style="height:100%" ref="modalUserRole"></OrderInfor>
      </a-drawer>
      <!-- 添加轨迹对话框 -->
      <add-trajectory ref="addTrajectoryModal" @refresh="loadData"/>
      <!-- 修改单号对话框 -->
      <modify-order-number-modal ref="modifyOrderModal" :selected-rows="selectedRowsArray" @refresh="loadData"
                                 @clear-selection="clearSelection"/>
      <!-- 在现有模态框后面添加 -->
      <payment-outbound-modal
          ref="paymentOutboundModal"
          :visible="paymentOutboundModalVisible"
          :selected-orders="selectedRowsArray"
          @submit="handlePaymentOutbound"
          @success="handlePaymentSuccess"
          @cancel="paymentOutboundModalVisible = false"
      />

      <!-- 新增：修改支付状态对话框 -->
      <a-modal
          v-if="editModalVisible"
          title="修改支付状态"
          :visible="editModalVisible"
          @ok="handleEditOk"
          @cancel="handleEditCancel"
          :confirmLoading="confirmLoading"
      >
        <a-form :form="editForm">
          <!-- 新增：显示当前订单信息 -->
          <a-form-item label="订单编号" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <a-tag color="blue">{{ currentRecord.barCodeNo || '--' }}</a-tag>
          </a-form-item>

          <a-form-item label="原始收款状态" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <a-tag :color="currentRecord.isPayment == '0' ? 'red' : 'green'">
              {{ currentRecord.isPayment == '0' ? '未收款' : '已收款' }}
            </a-tag>
          </a-form-item>

          <a-form-item label="修改状态" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <a-select
                v-decorator="[
          'isPayment',
          {rules: [{ required: true, message: '请选择收款状态' }]}
        ]"
                placeholder="请选择收款状态"
                @change="handlePaymentStatusChange"
                :disabled="currentRecord.isPayment == '1'"
            >
              <a-select-option value="0">未收款</a-select-option>
              <a-select-option value="1">已收款</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="交易号" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <a-input
                v-decorator="[
          'transactionId',
          {rules: [{ required: true, message: '请输入您的交易号' }]}
        ]"
                placeholder="请输入您的交易号"
            />
          </a-form-item>
          <a-form-item label="收款金额" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <a-input
                v-decorator="[
          'payAmount',
          {rules: [{ required: true, message: '请输入您的收款金额' }]}
        ]"
                type="number"
                placeholder="请输入您的收款金额"
            />
          </a-form-item>
          <a-form-item
              v-if="editForm.getFieldValue('isPayment') === '1'"
              label="收款时间"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 19}"
          >
            <a-date-picker
                v-decorator="['paymentTime',{rules: [{ required: false }]}]"
                show-time
                format="YYYY-MM-DD HH:mm:ss"
                style="width: 100%"
                placeholder="请选择收款时间（可选）"
            />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <!-- table区域-end -->
  </a-card>
</template>

<script>
//import Ordercreater from './modules/Ordercreater'
import {message} from 'ant-design-vue';
import OrderInfor from './modules/OrderInfor.vue'
import {dictGet, updatePaymentStatus, selectStatistics} from 'api/app'
import {TableListMixin} from '@/situation/mixins/tableListMixin'
import {AsyncExportMixin} from '@/mixins/asyncExportMixin'
import {filterObj} from 'utils/util';
import AddTrajectory from './modules/AddTrajectory.vue'
import ModifyOrderNumberModal from './modules/ModifyOrderNumberModal.vue'
import PaymentOutboundModal from './modules/PaymentOutboundModal.vue'
import {mapGetters} from 'vuex'

export default {
  name: "dashboard_order",
  mixins: [TableListMixin, AsyncExportMixin],
  components: {
    //Ordercreater,
    OrderInfor,
    AddTrajectory,
    ModifyOrderNumberModal,
    PaymentOutboundModal
  },
  computed: {
    aDouble() {
      return function (value) {
        return this.dictEum[value] ? this.dictEum[value] : ""
      }
    },
    getTagColor() {
      return function (value) {
        const colorMap = {
          '0': 'red',
          '1': 'green',
          '2': 'geekblue',
          '3': 'pink',
          '4': 'gold',
          '5': 'orange',
          '6': 'purple',
          '7': 'cyan',
          '8': 'gold'
        }
        return colorMap[value] || 'default'
      }
    },
    paymentStatus() {
      return function (value) {
        if (value == '0') {
          return '未收款'
        } else if (value == 1) {
          return '已收款'
        } else {
          return '';
        }
      }
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  async created() {
    const routeParam = this.$route.params

    if (routeParam.siteId) {
      this.queryParam.siteId = routeParam.siteId
    }

    if (routeParam.orderStatus) {
      this.queryParam.orderStatus = routeParam.orderStatus
    }

    if (routeParam.startTime) {
      this.queryParam.createTimeRend = [routeParam.startTime, routeParam.endTime]
    }

    let dictEum = await dictGet({
      dictType: ""
    })
    this.dictEum = dictEum.data.order_status
    this.dictSettlemenTypeEum = dictEum.data.settlemen_type
  },
  mounted() {
    console.log("mounted", this.$route.query)
    this.selectedItemsAll = this.siteInfo()
    this.selectedItems = JSON.parse(JSON.stringify(this.selectedItemsAll))
  },
  data() {
    return {
      labelCol: {
        xs: {span: 1},
        sm: {span: 2},
      },
      wrapperCol: {
        xs: {span: 12},
        sm: {span: 18},
      },
      modifyOrderModalVisible: false,
      selectedRowsArray: [],
      dictEum: {},
      dictSettlemenTypeEum: {},
      orderInforData: {},
      drawerTitle: this.$t("dashboard.order.darcodeInfor"),
      drawerVisible: false,
      description: '角色管理页面',
      // 查询条件
      queryParam: {roleName: '',},
      editModalVisible: false, // 控制编辑模态框显示
      confirmLoading: false, // 提交加载状态
      currentRecord: null, // 当前编辑的记录
      editForm: this.$form.createForm(this), // 编辑表单
      selectStatistics: {},
      paymentOutboundModalVisible: false,
      // 表头
      columns: [
        {
          title: this.$t('dashboard.order.waybillNumber'),
          dataIndex: 'waybillNumber',
          align: "center",
          fixed: 'left',
          width: 150
        },
        {
          title: this.$t('dashboard.order.barCodeNo'),
          align: "center",
          dataIndex: 'barCodeNo',
          fixed: 'left',
          width: 150
        },
        {
          title: this.$t('dashboard.order.wcBarCodeNo'),
          align: "center",
          dataIndex: 'wcBarCodeNo',
          width: 180
        },
        {
          title: this.$t('dashboard.order.siteName'),
          align: "center",
          dataIndex: 'siteName',
          width: 180
        },
        {
          title: this.$t('dashboard.order.orderStatus'),
          dataIndex: 'orderStatus',
          align: "center",
          scopedSlots: {customRender: 'tags'},
          width: 100
        }, {
          title: this.$t('dashboard.order.isPayment'),
          dataIndex: 'isPayment',
          align: "center",
          scopedSlots: {customRender: 'paymentStatus'},
          width: 100
        },
        {
          title: this.$t('dashboard.order.toCustIdCardNo'),
          dataIndex: 'toCustIdCardNo',
          align: "center",
          width: 180
        },
        {
          title: this.$t('dashboard.order.toCustLinkman'),
          dataIndex: 'toCustLinkman',
          align: "center",
          width: 180
        },
        {
          title: this.$t('dashboard.order.toCustTel'),
          dataIndex: 'toCustTel',
          align: "center",
          width: 150
        }, {
          title: this.$t('dashboard.order.productCode'),
          dataIndex: 'productCode',
          align: "center",
          width: 150
        },
        {
          title: this.$t('dashboard.order.inboundTime'),
          dataIndex: 'inboundTime',
          align: "center",
          width: 150
        }, {
          title: this.$t('dashboard.order.outboundTime'),
          dataIndex: 'outboundTime',
          align: "center",
          width: 150
        },
        {
          title: this.$t('dashboard.order.createTime'),
          dataIndex: 'createTime',
          align: "center",
          width: 150
        }, {
          title: this.$t('dashboard.order.paymentTime'),
          dataIndex: 'paymentTime',
          width: 150,
          align: "center"
        },
        {
          title: this.$t('antd.table.batch'),
          dataIndex: 'action',
          align: "center",
          width: 100,
          fixed: 'right',
          scopedSlots: {customRender: 'action'},
        }
      ],
      url: {
        selectData: "/ndt/order/page",
        deleteData: "",
        exportXlsUrl: "/ndt/order/export",
        exportTaskUrl: "/ndt/export/task/order/async",
        exportStatusUrl: "/ndt/export/task/status",
        exportDownloadUrl: "ndt/export/task/download"
      },
    }
  },
  methods: {
    ...mapGetters(["siteInfo"]),
    // 支付出库成功后的处理
    handlePaymentSuccess() {
      console.log("成功之后进行数据加载关闭弹框")
      this.loadData() // 刷新数据
      this.handleClearSelection() // 清空选中项
      this.paymentOutboundModalVisible = false
    },
    // 支付出库处理
    handlePaymentOutbound() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请至少选择一条订单')
        return
      }

      // 检查是否全部已支付
      const hasUnpaid = this.selectedRowsArray.some(item => item.isPayment != '1')
      if (hasUnpaid) {
        this.$message.error('只能选择已收款的订单进行出库操作！')
        return
      }
      // 检查是否全部已入库
      const hasNoStore = this.selectedRowsArray.some(item => item.orderStatus == '0')
      if (hasNoStore) {
        this.$message.error('存在未入库订单，不允许进行出库操作！')
        return
      }

      // 检查是否存在退件订单
      const hasReturnOrder = this.selectedRowsArray.some(item => item.orderStatus == '5')
      if (hasReturnOrder) {
        this.$message.error('存在已退件订单，不允许直接进行出库操作！')
        return
      }

      // 检查是否存在已签收订单
      const hasSignOrder = this.selectedRowsArray.some(item => item.orderStatus == '2')
      if (hasSignOrder) {
        this.$message.error('存在已签收订单，请确定订单再进行出库！')
        return
      }

      if (this.selectedRowsArray.length > 50) {
        this.$message.error('一次最多操作50个订单，请分批操作')
        return
      }
      this.paymentOutboundModalVisible = true;
    },
    handlePaymentStatusChange(value) {
      // 当状态切换为未收款时，清空支付时间
      if (value === '0') {
        this.editForm.setFieldsValue({
          paymentTime: null
        });
      }
    },
    clearSelection() {
      this.selectedRowsArray = [] // 清空选中项
      this.selectedRowKeys = [] // 清空选中项
      // 如果有表格组件引用，可以调用其方法取消选中状态
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
    },
    handleClearSelection() {
      this.onClearSelected();
      this.getSelectStatistics([])
    },
    handleSearchQuery() {
      this.searchQuery()
      this.onClearSelected();
      this.getSelectStatistics([])
    },
    handleSearchReset() {
      this.searchReset({}, 0);
      this.onClearSelected();
      this.getSelectStatistics([])
    },
    handleModifyOrderNumber() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请至少选择一条订单')
        return
      }
      this.$refs.modifyOrderModal.openModal()
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      // 1. 获取当前页所有行的ID
      const currentPageRowIds = this.dataSource
          .slice(
              (this.ipagination.current - 1) * this.ipagination.pageSize,
              this.ipagination.current * this.ipagination.pageSize
          )
          .map(row => row.id);

      // 2. 先移除所有当前页的行（无论是否选中）
      this.selectedRowsArray = this.selectedRowsArray.filter(
          row => !currentPageRowIds.includes(row.id)
      );

      // 3. 再把当前页新选中的行加回去（使用Set去重）
      const selectedRowsIds = new Set(this.selectedRowsArray.map(row => row.id));
      const uniqueSelectedRows = selectedRows.filter(row => !selectedRowsIds.has(row.id));
      this.selectedRowsArray = [...this.selectedRowsArray, ...uniqueSelectedRows];

      // 4. 更新选中的keys（这个应该只反映当前页的选择状态）
      this.selectedRowKeys = selectedRowKeys;

      // 创建Set用于快速查找
      const selectedKeysSet = new Set(this.selectedRowKeys)
      // 确保selectedRowsArray是数组
      const rows = Array.isArray(this.selectedRowsArray) ? this.selectedRowsArray : []

      // 筛选出存在于selectedRowKeys中的数据
      this.selectedRowsArray = rows.filter(item =>
          item && item.id && selectedKeysSet.has(item.id.toString()) // 确保id转为字符串比较
      )
      console.log('selectedRows:', selectedRows)
      console.log('selectedRowKeys:', selectedRowKeys)
      this.getSelectStatistics(selectedRowKeys);
    },

    getSelectStatistics(selectedRowKeys) {
      if (selectedRowKeys.length == 0) {
        this.selectStatistics = {}
        return
      }
      const params = {
        selectIdList: selectedRowKeys
      }
      selectStatistics(params).then(res => {
        if (res.code == 200) {
          console.log('res:', res)
          this.selectStatistics = res.data
        } else {
          console.log(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 显示编辑模态框
    showEditModal(record) {
      this.currentRecord = record
      if (this.currentRecord.orderStatus == 8){
        this.$message.error('已销毁订单不允许修改支付状态');
        return;
      }
      this.editModalVisible = true
      this.$nextTick(() => {
        this.editForm.setFieldsValue({
          isPayment: record.isPayment.toString(),
          payAmount: record.payAmount ? Number(record.payAmount) : record.amount ? Number(record.amount) : null,
          transactionId: record.transactionId
        })
      })
    },
    // 编辑模态框确定
    handleEditOk() {
      this.editForm.validateFields((err, values) => {
        if (!err) {
          if (this.currentRecord.orderStatus != 0 
              && this.currentRecord.orderStatus != 1 
              && this.currentRecord.orderStatus != 3 
              && this.currentRecord.orderStatus != 5
              && this.currentRecord.orderStatus != 4
          ) {
            message.error('已经签收的订单不允许修改支付状态');
            return;
          }

          if (this.currentRecord.isPayment == 1 && values.isPayment == 0) {
            message.error('已收款订单不允许修改为未收款状态');
            return;
          }

          // if (values.isPayment == 1 && this.currentRecord.amount < values.payAmount) {
          //   message.error('收款金额不能大于订单金额');
          //   return;
          // }

          this.confirmLoading = true
          const params = {
            barCodeNo: this.currentRecord.barCodeNo,
            isPayment: values.isPayment,
            paymentTime: values.paymentTime,
            payAmount: values.payAmount,
            transactionId: values.transactionId,
          }

          updatePaymentStatus(params).then(res => {
            if (res.code === 200) {
              message.success('标签更新成功')
              this.loadData() // 刷新表格数据
              this.editModalVisible = false
            } else {
              message.error(res.msg || '更新失败')
            }
          }).catch(error => {
            message.error(error.message || '请求失败')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },

    // 编辑模态框取消
    handleEditCancel() {
      this.editModalVisible = false
      this.editForm.resetFields()
    },
    // 添加轨迹方法
    handleAddTrajectory() {
      this.$refs.addTrajectoryModal.openModal()
      this.$refs.addTrajectoryModal.clearMentionInput();
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.current = this.ipagination.current;
      param.size = this.ipagination.pageSize;
      delete param.createTimeRange; // 时间参数不传递后台
      delete param.createTimeRend; // 时间参数不传递后台
      delete param.payTimeRange; // 时间参数不传递后台
      if (this.superQueryParams) {
        param['superQueryParams'] = encodeURI(this.superQueryParams)
        param['superQueryMatchType'] = this.superQueryMatchType
      }
      return filterObj(param);
    },
    onDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.outboundStartTime = dateString[0];
      this.queryParam.outboundEndTime = dateString[1];
    },
    onCreatDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.startTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    },
    onPayDateChange: function (value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.paymentStartTime = dateString[0];
      this.queryParam.paymentEndTime = dateString[1];
    },
    onClose() {
      this.$refs.modalUserRole.close();
      this.drawerVisible = false
    },
    onDrawerClose() {
      this.drawerVisible = false
    },
    handleInfor(record) {
      this.drawerVisible = true
      this.orderInforData = record
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    onChangeDate(date, dateString) {
      console.log(date, dateString);
    },
    onDateOk(value) {
      console.log(value);
    },
  }
}
</script>
<style lang="less" scoped>
@import '~assets/less/common.less';

.ant-table-wrapper {
  overflow-x: auto;
}
</style>
